import { render } from "./TopPost.vue?vue&type=template&id=6606c327&scoped=true"
import script from "./TopPost.vue?vue&type=script&lang=js"
export * from "./TopPost.vue?vue&type=script&lang=js"

import "./TopPost.vue?vue&type=style&index=0&id=6606c327&lang=scss&scoped=true"
import "./TopPost.vue?vue&type=style&index=1&id=6606c327&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6606c327"]])

export default __exports__